import { useContext, useEffect } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Loader from "../../components/Loader";
import context from "../../context/context";

const LoginDirect = () => {
  const navigate = useNavigate();
  const { setUserStatus, userToken, setUserToken, setCharCode } = useContext(context);

  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { charCode } = useParams();

  // Salva o charCode da URL no contexto/localStorage
  useEffect(() => {
    if (charCode) {
      localStorage.setItem("charCode", charCode);
      setCharCode(charCode);
    }
  }, [charCode, setCharCode]);

  // Extrai o token da URL e salva no contexto/localStorage
  useEffect(() => {
    const token = searchParams.get("t");
    if (token) {
      localStorage.setItem("userToken", token);
      localStorage.setItem("userStatus", "true");
      setUserToken(token);
      setUserStatus("true");
    } else {
      const dynamicSegment = charCode || location.pathname.split("/").pop();
      navigate(`/auth/login/${dynamicSegment}`);
    }
  }, []);

  // Navega para home quando o token estiver disponível no contexto
  useEffect(() => {
    if (userToken) {
      navigate("/");
    }
  }, [userToken]);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div
      className="login-page h-screen flex justify-center items-center"
      style={{ overflow: "hidden" }}
    >
      <Loader />
    </div>
  );
};

export default LoginDirect;
